import classNames from 'classnames'
import Image from 'components/image'
import css from './install-extension-instructions.scss'

interface InstallExtensionInstructionsProps {
  className?: string
}

const InstallExtensionInstructions = (
  props: InstallExtensionInstructionsProps
) => {
  const { className } = props

  return (
    <div className={classNames(className, css.InstallExtensionInstructions)}>
      <Image
        alt="chrome installation instructions"
        role="presentation"
        src="https://images.babylist.com/image/upload/v1705608682/Onboarding/Extension-img.png"
      />
    </div>
  )
}

export default InstallExtensionInstructions
